import { SelectColumnFilter } from 'components/dataTables/FilterTypes/SelectColumnFilter';
import EditButton from 'pages/admin/demand/planning/components/editButton/EditButton';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';

export const columnsDataViewPlanning = (planningType: PlanningTypes) => [
	{
		Header: 'Ano',
		accessor: 'year',
		type: 'text',
		Filter: SelectColumnFilter,
		filter: 'equals',
	},
	{
		Header: 'Ciclo',
		accessor: 'cycle',
		disableSortBy: true,
		type: 'text',
		Filter: SelectColumnFilter,
		filter: 'equals',
	},
	...(planningType === 'collaboration'
		? [
				{
					Header: 'Colaborador',
					accessor: 'companyAreaName',
					type: 'relation',
					Filter: SelectColumnFilter,
					filter: 'equals',
				},
		  ]
		: []),
	{
		Header:
			planningType === 'consensus'
				? 'Consenso Completo'
				: 'Colaboração Completa',
		accessor: 'completed',
		type: 'toggleAndEditModal',
		filter: false,
		helper: true,
		optional: true,
		isModal: true,
	},
	{
		Header: '',
		accessor: 'button',
		type: 'jsx',
		jsx: EditButton,
		filter: false,
	},
];
